import { tryFetch } from "./FetchAPI";
import { getTokenOrDefault } from "./Storage";

export interface CartItemPayload {
  store_id: string;
  items: string[];
  voucher_id?: string;
}

export interface ShippingStore {
  store_id: string;
  store_name: string;
  items: any[];
  voucher: any[] | null;
  shipping_fee: string;
  admin_fee: string;
  order_total: string;
}

export interface MerchandiseResponse {
  request_id: string;
  cart: ShippingStore[];
  merchandise_subtotal: string;
  shipping_subtotal: string;
  admin_fee_subtotal: string;
  total_payable: string;
}

export interface LalamoveStoreResponse {
  id: string;
  request_id: string;
  shipping_fee: string;
  order_total: string;
}

const isMerchandiseResponse = (data: any): data is MerchandiseResponse => {
  return (
    data &&
    typeof data === "object" &&
    typeof data.request_id === "string" &&
    Array.isArray(data.cart) &&
    typeof data.merchandise_subtotal === "string" &&
    typeof data.admin_fee_subtotal === "string" &&
    typeof data.total_payable === "string"
  );
};

const isLalamoveArray = (data: any): data is LalamoveStoreResponse[] => {
  return (
    Array.isArray(data) &&
    data.every(
      (item) =>
        item &&
        typeof item.id === "string" &&
        typeof item.request_id === "string" &&
        typeof item.shipping_fee === "string" &&
        typeof item.order_total === "string"
    )
  );
};

export const calculateMerchandiseData = async (
  customer_address_id: string,
  cart: CartItemPayload[],
  platform_voucher_id?: string
): Promise<MerchandiseResponse> => {
  const token = getTokenOrDefault();
  const payload: { customer_address_id: string; cart: CartItemPayload[]; platform_voucher_id?: string } = {
    customer_address_id,
    cart,
  };

  if (platform_voucher_id) payload.platform_voucher_id = platform_voucher_id;
  // const payload = { customer_address_id, cart };
  //   if (platform_voucher_id) payload.platform_voucher_id = platform_voucher_id;

  const response = await tryFetch({
    url: "/g/calculate-shipping",
    method: "POST",
    token,
    payload,
  });

   if (!response.is_success || !isMerchandiseResponse(response.data)) {
    throw new Error(
      response.errors?.join(", ") || "Failed to calculate merchandise data"
    );
  }


  return response.data;
};

export const calculateMerchantVoucherData = async (
  customer_address_id: string,
  cart: CartItemPayload[],
  platform_voucher_id?: string
): Promise<MerchandiseResponse> => {
  const token = getTokenOrDefault();
  const payload: { customer_address_id: string; cart: CartItemPayload[]; platform_voucher_id?: string } = {
    customer_address_id,
    cart,
  };

  if (platform_voucher_id) payload.platform_voucher_id = platform_voucher_id;

  // const payload = { customer_address_id, cart };
  //  if (platform_voucher_id) payload.platform_voucher_id = platform_voucher_id;

  const response = await tryFetch({
    url: "/g/calculate-shipping",
    method: "POST",
    token,
    payload,
  });

   if (!response.is_success || !isMerchandiseResponse(response.data)) {
    throw new Error(
      response.errors?.join(", ") ||
        "Failed to calculate merchant voucher"
    );
  }

  return response.data;
};

export const calculatePlatformVoucherData = async (
  customer_address_id: string,
  cart: CartItemPayload[],
  platform_voucher_id: string
): Promise<MerchandiseResponse> => {
  const token = getTokenOrDefault();
  const payload = { customer_address_id, cart, platform_voucher_id };

  const response = await tryFetch({
    url: "/g/calculate-shipping",
    method: "POST",
    token,
    payload,
  });

  if (!response.is_success || !isMerchandiseResponse(response.data)) {
    throw new Error(
      response.errors?.join(", ") ||
        "Failed to calculate platform voucher"
    );
  }

  return response.data;
};

export const calculateLalamoveShipping = async (
  request_id: string,
  cart: CartItemPayload[]
): Promise<LalamoveStoreResponse[]> => {
  const token = getTokenOrDefault();
  const payload = { request_id, cart };

  const response = await tryFetch({
    url: "/g/calculate-shipping-lalamove",
    method: "POST",
    token,
    payload,
  });

    if (!response.is_success || !isLalamoveArray(response.data)) {
    throw new Error(
      response.errors?.join(", ") ||
        "Invalid Lalamove shipping response structure"
    );
  }

  return response.data;
};
